var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18034_11775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7995 13.1632C11.5877 12.3658 11.1297 11.6532 10.4879 11.1285C9.78583 10.5547 8.90695 10.2412 8.00019 10.2412C7.09343 10.2412 6.21456 10.5547 5.51248 11.1285C4.87065 11.6532 4.41267 12.3658 4.20093 13.1632",
    stroke: "#353945",
    strokeWidth: 1.2084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6663C12.2667 14.6663 14.6667 12.2663 14.6667 7.99967C14.6667 3.73301 12.2667 1.33301 8.00004 1.33301C3.73337 1.33301 1.33337 3.73301 1.33337 7.99967C1.33337 12.2663 3.73337 14.6663 8.00004 14.6663Z",
    stroke: "#353945",
    strokeWidth: 1.2084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99908 8.5946C9.43498 8.5946 10.2427 7.78691 10.2427 6.35101C10.2427 4.91511 9.43498 4.10742 7.99908 4.10742C6.56319 4.10742 5.75549 4.91511 5.75549 6.35101C5.75549 7.78691 6.56319 8.5946 7.99908 8.5946Z",
    stroke: "#353945",
    strokeWidth: 1.2084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18034_11775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon7);
export default __webpack_public_path__ + "static/media/navicon7.177b391396824c532183a26f5771c7fc.svg";
export { ForwardRef as ReactComponent };